import { fromBanglaDigits, MoneyError, parseTaka, QTY_SCALE } from "@zeeta/shared";

/** Parses user-entered taka into poisha; null for empty or invalid input. */
export function tryParseTaka(text: string): number | null {
  if (text.trim() === "") return null;
  try {
    return parseTaka(text);
  } catch (error) {
    if (error instanceof MoneyError) return null;
    throw error;
  }
}

/** Parses a decimal quantity ("1.5", "১.৫") into milli units; null when invalid or over 3 decimals. */
export function tryParseQty(text: string): number | null {
  const normalized = fromBanglaDigits(text).replace(/[,\s]/g, "");
  const match = /^(\d{1,9})(?:\.(\d{1,3}))?$/.exec(normalized);
  if (!match) return null;
  const [, whole = "0", fraction = ""] = match;
  return Number(whole) * QTY_SCALE + Number(fraction.padEnd(3, "0"));
}

/** Poisha as an editable taka string without grouping: 12550 → "125.5". */
export function takaText(poisha: number | null | undefined): string {
  if (poisha === null || poisha === undefined) return "";
  const sign = poisha < 0 ? "-" : "";
  const abs = Math.abs(poisha);
  const whole = Math.floor(abs / 100);
  const frac = String(abs % 100)
    .padStart(2, "0")
    .replace(/0+$/, "");
  return `${sign}${whole}${frac ? `.${frac}` : ""}`;
}

export function qtyText(milli: number | null | undefined): string {
  if (milli === null || milli === undefined) return "";
  const whole = Math.floor(milli / QTY_SCALE);
  const frac = String(milli % QTY_SCALE)
    .padStart(3, "0")
    .replace(/0+$/, "");
  return `${whole}${frac ? `.${frac}` : ""}`;
}

/** Start and end (exclusive) of a Dhaka calendar day, in epoch ms. */
export function dhakaDayRange(daysAgo = 0, span = 1): { from: number; to: number } {
  const offset = 6 * 3_600_000;
  const now = Date.now() + offset;
  const startOfToday = now - (now % 86_400_000) - offset;
  const from = startOfToday - daysAgo * 86_400_000;
  return { from, to: from + span * 86_400_000 };
}
